import { TableCell, TableRow } from '@material-ui/core';
import moment from 'moment';
import React from 'react';

const WLTableCells = ({ styles, mykey, row, date, latestPrice, symbol }) => {
  return (
    <TableRow style={{ ...styles.tableRow, height: '5px' }} key={mykey}>
      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          width: '70px',
        }}
        align="center"
      >
        {moment(date).format('DD-MMM-YY')}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          width: '45px',
        }}
        align="center"
      >
        ${parseFloat(latestPrice).toFixed(2)}
      </TableCell>
      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          width: '45px',
        }}
        align="center"
      >
        {symbol}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          width: '45px',
        }}
        align="center"
      >
        {moment(row.expiry).format('DD-MMM-YY')}
      </TableCell>
      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          width: '45px',
        }}
        align="center"
      >
        ${typeof row === 'object' && row.strike.toFixed(2)}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          textAlign: 'center',
          width: '45px',
        }}
        align="center"
      >
        {row.put_call}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          width: '45px',
        }}
        align="center"
      >
        ${typeof row === 'object' && row.theo_ask.toFixed(2)}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          width: '45px',
          backgroundColor: '#FFFCD1',
        }}
        align="center"
      >
         {row.RR ?  '$' + row.RR.toFixed(2) : '-'}
      </TableCell>
    </TableRow>
  );
};

export default WLTableCells;



// WEBPACK FOOTER //
// ./src/components/Modals/WatchListAdd/components/WLTableCells.jsx